// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f2227814","505":"dde37bb9","748":"6f906dcc"}[chunkId] + ".chunk.js";
};